import OptionsTypeConfig from './OptionsTypeConfig';

export default class RadioTypeConfig extends OptionsTypeConfig{

}
